import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import "react-phone-input-2/lib/style.css";

// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import logo from "../../assets/images/logo.webp";
import letterLogo from "../../assets/images/letter-logo.webp";
import topLogo from "../../assets//images/top-logo.webp";
import LanguageSwitcher from "../../components/LanguageSelector";
import { useTranslation } from "react-i18next";

const auth = getAuth();

interface LoginProps {}

type ContactFormTypes = {
  first_name: string;
  last_name: string;
  email: string;
  topic: string;
  message: string;
  is_accept_terms: boolean;
};

const Imprint = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const handleLogoClick = () => {
    navigate("/landing-page");
  };

  return (
    <div className="contact-us">
      <div className=" flex-grow-1">
        <Navbar expand="lg" className="px-3 pt-3">
          <Container fluid>
            {/* Left: Logo */}
            <Navbar.Brand
              onClick={handleLogoClick}
              style={{ cursor: "pointer" }}
            >
              <img
                src={topLogo}
                alt="Logo"
                width="160"
                height="40"
                className="d-inline-block align-center"
              />
            </Navbar.Brand>
            <span className="d-flex gap-3">
              <span className="d-block d-lg-none">
                <LanguageSwitcher />
              </span>
              <Navbar.Toggle
                aria-controls="offcanvasNavbar-expand"
                style={{ fontSize: "1rem", padding: "5px 7px" }}
              />
              <Navbar.Offcanvas
                id="offcanvasNavbar-expand"
                aria-labelledby="offcanvasNavbarLabel-expand"
                placement="end" // Right side
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel-expand">
                    {t("Menu")}
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  {/* Center-Right: Menu Items */}
                  <Nav className="ms-auto me-3">
                    <Button
                      className="rounded-pill py-1 d-none d-lg-block"
                      style={{
                        backgroundColor: "#ede7e7",
                        color: "gray",
                        borderColor: "#ede7e7",
                        paddingRight: "40px",
                        paddingLeft: "40px",
                      }}
                      onClick={() =>
                        window.open(
                          "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                          "_blank",
                        )
                      }
                    >
                      {t("Donate")}
                    </Button>
                    <Nav.Link as={Link} to="/about-us" className="contact-text">
                      {t("ABOUT US")}
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/learn-more"
                      className="contact-text"
                    >
                      {t("LEARN MORE")}
                    </Nav.Link>
                  </Nav>

                  {/* Right: Button */}

                  <Button
                    className="rounded-pill py-1 d-block d-lg-none my-3 w-100"
                    style={{
                      backgroundColor: "#ede7e7",
                      color: "gray",
                      borderColor: "#ede7e7",
                      paddingRight: "40px",
                      paddingLeft: "40px",
                    }}
                  >
                    {t("Donate")}
                  </Button>
                  <Button
                    className="rounded-pill px-3 py-1 d-none d-lg-block"
                    style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                    onClick={() => {
                      navigate("/auth-register");
                    }}
                  >
                    {t("Try out for free")}
                  </Button>
                  <Button
                    className="rounded-pill px-3 py-1 w-100 d-block d-lg-none"
                    style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                    onClick={() => {
                      navigate("/auth-register");
                    }}
                  >
                    {t("Try out for free")}
                  </Button>
                  <span className="d-none d-lg-block">
                    <LanguageSwitcher />
                  </span>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </span>
          </Container>
        </Navbar>
        <Container className="learnmore-top">
          <h1>{t("Imprint")}</h1>
          <section
            id="section1"
            className="learnmore-section"
            style={{ color: "gray" }}
          >
            <p className="fw-bold">{t("Digital Heroes")}</p>
            <p>Tobias Krüger </p>
            <p>Frankenstraße 8</p>
            <p>92353 Postbauer-Heng</p>
            <p>{t("Germany")}</p>
            <p></p>
            <p>Tel: +49 177/5587892</p>
            <p>e-Mail: info@hero-invoice.com</p>
          </section>
          <section
            id="section2"
            className="learnmore-section"
            style={{ color: "gray" }}
          >
            <p className="fw-bold">{t("Image credits")}</p>
            <div className="d-flex flex-column">
              <a
                target="_blank"
                href="https://www.flaticon.com/free-icons/facebook"
                title="facebook icons"
                style={{ color: "#235e88" }}
              >
                {t("Facebook icons created by Laisa Islam Ani - Flaticon")}
              </a>
              <a
                target="_blank"
                href="https://www.flaticon.com/free-icons/linkedin"
                title="linkedin icons"
                style={{ color: "#235e88" }}
              >
                {t("Linkedin icons created by Laisa Islam Ani - Flaticon")}
              </a>
              <a
                target="_blank"
                href="https://www.flaticon.com/free-icons/web-site"
                title="web site icons"
                style={{ color: "#235e88" }}
              >
                {t("Web site icons created by BizzBox - Flaticon")}
              </a>
              <a
                target="_blank"
                href="https://www.flaticon.com/free-icons/github"
                title="github icons"
                style={{ color: "#235e88" }}
              >
                {t("Github icons created by IconsBox - Flaticon")}
              </a>
              <a
                target="_blank"
                href="https://www.flaticon.com/free-icons/gofundme"
                title="gofundme icons"
                style={{ color: "#235e88" }}
              >
                {t("Gofundme icons created by Pixel perfect - Flaticon")}
              </a>
            </div>
          </section>
        </Container>
      </div>

      <div className="footer mt-4">
        <div className="footer-divider"></div>
        <Navbar expand="lg" className="px-3 pt-3">
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>

          {/* Center-Right: Menu Items */}
          <Nav className="ms-auto me-3">
            <Nav.Link as={Link} to="/imprint" className="text-gray">
              {t("Imprint")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/terms" className="text-gray">
              {t("Terms of Use")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/privacy" className="text-gray">
              {t("Privacy Policy")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className="text-gray">
              {t("Contact")}
            </Nav.Link>
          </Nav>
        </Navbar>
      </div>
    </div>
  );
};

export default Imprint;
